export default __webpack_public_path__ + "static/TrustAlice Illustrations--07-5fcbf59a95499d284eb8dca83ff15224.svg";